import React from 'react'
import UserLogComponents from '../../Components/UserLog/UserLogComponents';

const UserLog = () => {
  return <div><UserLogComponents/></div>;
}

export default UserLog
